import {ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule,} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';

import {CoreModule} from './core/core.module';
import {ApiInterceptor} from 'src/app/core/interceptors/api.interceptor';

import myLocaleRu from '@angular/common/locales/ru-KZ';
import {registerLocaleData} from '@angular/common';
import {ErrorInterceptor} from './core/interceptors/error.interceptor';
import {FullCalendarModule} from '@fullcalendar/angular';
import ru from '@angular/common/locales/ru';
import kk from '../assets/i18n/kkt';

import {kk as kkLocale} from 'date-fns/locale';

import {environment} from '../environment';
import {getErrorHandler} from './core/handlers/sentry-error.handler';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {ItemsFallingAnimComponent} from './shared/components/items-falling-anim/items-falling-anim.component';
import {initializeApp, provideFirebaseApp} from "@angular/fire/app";
import {getMessaging, provideMessaging} from "@angular/fire/messaging";
import {DateFnsAdapter, MAT_DATE_FNS_FORMATS, MatDateFnsModule} from "@angular/material-date-fns-adapter";
import {
  DateAdapter,
  ErrorStateMatcher,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  ShowOnDirtyErrorStateMatcher
} from "@angular/material/core";

registerLocaleData(myLocaleRu);
registerLocaleData(ru);
registerLocaleData(kk);

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    CoreModule,
    BrowserModule,
    FullCalendarModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideMessaging(() => getMessaging()),
    MatDateFnsModule,
    ItemsFallingAnimComponent,
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useFactory: getErrorHandler,
    },
    { provide: MAT_DATE_LOCALE, useValue: kkLocale},
    { provide: DateAdapter, useClass: DateFnsAdapter,deps: [MAT_DATE_LOCALE]},
    { provide: MAT_DATE_FORMATS, useValue: MAT_DATE_FNS_FORMATS},
    { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
  ],
})
export class AppModule {}
